module.exports = __webpack_public_path__ + "img/web2x_icon_yixianhuoren.ef4b21aa.png";